import React from 'react';
import { useAuth } from '../context/AuthContext';

function Sidebar({ activeTab, setActiveTab }) {
  const { user, logout } = useAuth();

  const isOrgAdmin = user?.is_admin;

  const menuItems = [
    { id: 'dashboard', label: 'Dashboard' },
    ...(isOrgAdmin ? [{ id: 'users', label: 'Users' }] : []),
    ...(isOrgAdmin ? [{ id: 'organizations', label: 'Organizations' }] : []),
    { id: 'videos', label: 'Videos' },
    { id: 'video-sessions', label: 'Video Sessions' },
    { id: 'vr-glasses', label: 'VR Glasses' },
    { id: 'questionnaires', label: 'Questionnaires' },
    { id: 'assessments', label: 'Assessments' },
    { id: 'ibs-form-submissions', label: 'IBS Form Submissions' },
    { id: 'downloads', label: 'Downloads' },
  ];

  return (
    <aside className="sidebar">
      <div className="sidebar-header">
        <h2>Admin Panel</h2>
      </div>

      <nav className="sidebar-nav">
        {menuItems.map((item) => (
          <button
            key={item.id}
            className={`nav-item ${activeTab === item.id ? 'active' : ''}`}
            onClick={() => setActiveTab(item.id)}
          >
            {item.label}
          </button>
        ))}
      </nav>

      <div className="sidebar-footer">
        <div className="user-info">
          <p className="user-name">{user?.full_name || user?.username}</p>
          {user?.organization_name && (
            <p className="user-org">{user.organization_name}</p>
          )}
          {user?.is_super_admin && (
            <p className="user-role">Super Admin</p>
          )}
        </div>
        <button className="btn-logout" onClick={logout}>
          Logout
        </button>
      </div>
    </aside>
  );
}

export default Sidebar;
